<template>
<div>
  <div v-if="_g_IsUserLogged && !_g_User.is_only_authenticated_user && _g_UserFeatures.has_active_role" class="stocks-container">
    <p class="stocks-info-query" title="Número de tickers distintos y entradas">
      <LegacyCollectionCounts :tickers="counter_stocks()" :entries="entryCount" />
      <span><div style="display: grid; top: 20px;"><span class="material-icons-outlined" style="margin-top: 14px;" @click="_previousTicker()">arrow_drop_up</span><span class="material-icons-outlined" @click="_nextTicker()">arrow_drop_down</span></div></span>
    </p>
    <button ref="orderTrigger" type="button" class="stocks-order-query" @click="_changeOrderType('open')" title="Ordenar listado" aria-haspopup="dialog" :aria-expanded="select_order_type">
      <span class="material-icons-outlined ekers-event-click">{{ icon_sort }}</span>
      <span class="key">{{order_type}}</span>
      <span class="material-icons-outlined ekers-event-click">{{ order_by_icon }}</span>
    </button>
    <LegacySortDialog v-if="select_order_type" :options="preferences_selected_to_order" :selected="order_type"
      @close="_changeOrderType('close')" @select="_orderedStock($event.field, $event.type, $event.name, $event.header)" />

    <ul id="my-list" class="mdc-list" role="listbox" v-if="not_ordered" @scroll.passive="$emit('chart-list-scroll')">
      <!-- Loading state -->
      <div v-if="legacyCollectionStatus.error" class="legacy-stocks-empty" role="alert">{{ legacyCollectionStatus.error }}</div>
      <div v-else-if="isInitialLoading || _g_is_loading_stocks || stocks === undefined || stocks === null" class="stocks-loading">
        <div class="loading-spinner">
          <div class="spinner"></div>
          <p>Cargando tickers...</p>
        </div>
      </div>
      <!-- Stocks list -->
      <div v-else-if="this.stocks != undefined && this.stocks.length != 0">
        <li class="mdc-list-item" v-bind="stockMembership(stock)" :class="{'mdc-list-item--selected' : isSameEntry(stock, selected_ticker)}" role="option" v-for="(stock, index) in stocks" :key="index">
          <span class="mdc-list-item__ripple"></span>
          <span v-if="stockMembership(stock)['data-stock-favorite']" class="legacy-stock-favorite-mark" aria-hidden="true"></span>
          <span v-if="stockMembership(stock)['data-stock-portfolio']" class="legacy-stock-portfolio-mark" aria-hidden="true"></span>
          <div class="legacy-stock-row-content">
          <div class="legacy-stock-row-main">
          <span v-if="_g_User.roles[21] || _g_User.roles[20]" class="mdc-list-item__text typo-body-2"
          :title="'Ticker: ' + stock.ticker 
          + title_break_line 
          + 'Pais: ' + stock.country
          + title_break_line 
          + 'Índice: ' + stock.index_valor
          + title_break_line 
          + 'Divisa: ' + stock.divisa
          + title_break_line 
          + 'Sector: ' + stock.sector + ' | ' + stock.industria
          + title_break_line
          + 'Tipo de entrada: ' + stock.entry_type_name
          + title_break_line
          + title_break_line
          + 'CFD: Su plan actual no tiene acceso al CFD'
          + title_break_line
          + 'Margen CFD: Su plan actual no tiene acceso al Margen CFD'
          ">{{ stock.ticker }}</span>
          <span v-else class="mdc-list-item__text typo-body-2"
          :title="'Ticker: ' + stock.ticker 
          + title_break_line 
          + 'Pais: ' + stock.country
          + title_break_line 
          + 'Índice: ' + stock.index_valor
          + title_break_line 
          + 'Divisa: ' + stock.divisa
          + title_break_line 
          + 'Sector: ' + stock.sector + ' | ' + stock.industria
          + title_break_line
          + 'Tipo de entrada: ' + stock.entry_type_name
          + title_break_line
          + title_break_line
          + 'CFD: ' + _checkCFD(stock)
          + title_break_line
          + 'Margen CFD: ' + stock.cfd_margin + '%'
          ">{{ stock.ticker }}</span>
          <span v-if="stock.nom && stock.nom !== '---'" class="legacy-stock-row-separator" aria-hidden="true">·</span>
          <span v-if="stock.nom && stock.nom !== '---'" class="legacy-stock-row-company" :title="stock.nom">{{ stock.nom }}</span>
          </div>
          <div v-if="stockRowDescription(stock)" class="legacy-stock-row-description" :title="stockRowDescription(stock)">{{ stockRowDescription(stock) }}</div>
          </div>
          <div class="legacy-stock-row-analysis">
            <LegacyEntryTag :value="stock.entry_type_name" />
            <LegacyEntryDirection :direction="stock.direccio" />
          </div>
        </li>
      </div>
      <!-- No results message (only show when not loading) -->
      <div v-else-if="!isInitialLoading && !_g_is_loading_stocks && stocks !== undefined && stocks !== null" class="stocks-query-not-found">
        <p>
          No existen tickers con esos criterios de búsqueda.
        </p>
      </div>
    </ul>
    <ul id="my-list" class="mdc-list" role="listbox" v-else @scroll.passive="$emit('chart-list-scroll')">
      <!-- Loading state -->
      <div v-if="legacyCollectionStatus.error" class="legacy-stocks-empty" role="alert">{{ legacyCollectionStatus.error }}</div>
      <div v-else-if="isInitialLoading || _g_is_loading_stocks || stocks === undefined || stocks === null" class="stocks-loading">
        <div class="loading-spinner">
          <div class="spinner"></div>
          <p>Cargando tickers...</p>
        </div>
      </div>
      <!-- Ordered stocks list -->
      <div v-else-if="this.stocks != undefined && this.stocks.length != 0">
        <li class="mdc-list-item" v-bind="stockMembership(stock)" :class="{'mdc-list-item--selected' : isSameEntry(stock, selected_ticker)}" role="option" v-for="(stock, index) in ordered_stocks" :key="ordered_stocks.length - index">
          <span class="mdc-list-item__ripple"></span>
          <span v-if="stockMembership(stock)['data-stock-favorite']" class="legacy-stock-favorite-mark" aria-hidden="true"></span>
          <span v-if="stockMembership(stock)['data-stock-portfolio']" class="legacy-stock-portfolio-mark" aria-hidden="true"></span>
          <div class="legacy-stock-row-content">
          <div class="legacy-stock-row-main">
          <span v-if="_g_User.roles[21] || _g_User.roles[20]" class="mdc-list-item__text typo-body-2"
          :title="'Ticker: ' + stock.ticker 
          + title_break_line 
          + 'Pais: ' + stock.country
          + title_break_line 
          + 'Índice: ' + stock.index_valor
          + title_break_line 
          + 'Divisa: ' + stock.divisa
          + title_break_line 
          + 'Sector: ' + stock.sector + ' | ' + stock.industria
          + title_break_line
          + 'Tipo de entrada: ' + stock.entry_type_name
          + title_break_line
          + title_break_line
          + 'CFD: Su plan actual no tiene acceso al CFD'
          + title_break_line
          + 'Margen CFD: Su plan actual no tiene acceso al Margen CFD'
          ">{{ stock.ticker }}</span>
          <span v-else class="mdc-list-item__text typo-body-2"
          :title="'Ticker: ' + stock.ticker 
          + title_break_line 
          + 'Pais: ' + stock.country
          + title_break_line 
          + 'Índice: ' + stock.index_valor
          + title_break_line 
          + 'Divisa: ' + stock.divisa
          + title_break_line 
          + 'Sector: ' + stock.sector + ' | ' + stock.industria
          + title_break_line
          + 'Tipo de entrada: ' + stock.entry_type_name
          + title_break_line
          + title_break_line
          + 'CFD: ' + _checkCFD(stock)
          + title_break_line
          + 'Margen CFD: ' + stock.cfd_margin + '%'
          ">{{ stock.ticker }}</span>
          <span v-if="stock.nom && stock.nom !== '---'" class="legacy-stock-row-separator" aria-hidden="true">·</span>
          <span v-if="stock.nom && stock.nom !== '---'" class="legacy-stock-row-company" :title="stock.nom">{{ stock.nom }}</span>
          </div>
          <div v-if="stockRowDescription(stock)" class="legacy-stock-row-description" :title="stockRowDescription(stock)">{{ stockRowDescription(stock) }}</div>
          </div>
          <div class="legacy-stock-row-analysis">
            <LegacyEntryTag :value="stock.entry_type_name" />
            <LegacyEntryDirection :direction="stock.direccio" />
          </div>
        </li>
      </div>
      <!-- No results message (only show when not loading) -->
      <div v-else-if="!isInitialLoading && !_g_is_loading_stocks && stocks !== undefined && stocks !== null" class="stocks-query-not-found">
        <p>
          No existen tickers con esos criterios de búsqueda.
        </p>
      </div>
    </ul>
    <div>
      <div v-if="selected_ticker && selected_ticker!=''">
        <Workspaces v-if="stocks != ''"
            ref="WorkspaceRef"
            :stocks="stocks"
            :stock="selected_ticker"
            :show_workspace="show_workspace"
            @_closeFavoriteWorkspacesWindow="_closeFavoriteWorkspacesWindow"
            @_favorite_added="_favorite_added"
            @_favorite_removed="_favorite_removed"
            @workspace_edited="_initWorkspaces">
        </Workspaces>

        <WaitingValues v-if="stocks != ''"
            ref="waiting"
            :stocks="stocks"
            :stock="selected_ticker"
            :show_waiting="show_waiting"
            @_closeWaitingValueWindow="_closeWaitingValueWindow"
            @waiting-added="getStocks">
        </WaitingValues>
      </div>
    </div>
  </div>

  <div v-else-if="_g_User.is_only_authenticated_user" class="stocks-container">
    <p class="stocks-info-query">
      <LegacyCollectionCounts :tickers="counter_stocks()" :entries="entryCount" />
    </p>
    <p class="stocks-order-query" style="cursor: not-allowed">
      <span class="material-icons-outlined ekers-event-click" style="cursor: not-allowed">{{ icon_sort }}</span>
      <span class="key">{{order_type}}</span>
      <span class="material-icons-outlined ekers-event-click" style="cursor: not-allowed">{{ order_by_icon }}</span>
    </p>

    <ul id="my-list" class="mdc-list blured" role="listbox">
      <li class="mdc-list-item" role="option" style="cursor: not-allowed" v-for="(stock, index) in stock_anonymous" :key="index">
        <span class="mdc-list-item" style="margin-left: -30px;"></span>
        <span class="mdc-list-item__text typo-body-2">{{ stock }}</span>
        <span class="alarm push mdc-list-item__meta material-icons" aria-hidden="true">schedule</span>
        <span
            class="favorite mdc-list-item__meta material-icons" 
            :class="{'active' : stock == 'D'}"
            aria-hidden="true">{{ iconFavorite(stock) }}</span>
        <!--<span data-action="addPortfolio" class="folder mdc-list-item__meta material-icons" aria-hidden="true">folder_open</span>
        <span data-action="addNotification" class="notifications mdc-list-item__meta material-icons" aria-hidden="true">notifications_none</span>-->
      </li>
    </ul>
    <div style="position:absolute; top: 100px; text-align: center; padding: 40px; cursor: not-allowed">
      <p><strong>Su plan no tiene acceso al listado de tickers. Pulse aquí para <a class="not-allowed-stocks" href="/app/store">cambiar de plan</a>.</strong></p>
    </div>
  </div>

  <div v-else class="stocks-container">
    <p class="stocks-info-query">
      <LegacyCollectionCounts tickers="???" entries="???" />
    </p>
    <p class="stocks-order-query" style="cursor: not-allowed">
      <span class="material-icons-outlined ekers-event-click" style="cursor: not-allowed">{{ icon_sort }}</span>
      <span class="key">{{order_type}}</span>
      <span class="material-icons-outlined ekers-event-click" style="cursor: not-allowed">{{ order_by_icon }}</span>
    </p>

    <ul id="my-list" class="mdc-list blured" role="listbox">
      <li class="mdc-list-item" role="option" style="cursor: not-allowed" v-for="(stock, index) in stock_anonymous" :key="index">
        <span class="mdc-list-item" style="margin-left: -30px;"></span>
        <span class="mdc-list-item__text typo-body-2">{{ stock }}</span>
        <span class="alarm push mdc-list-item__meta material-icons" aria-hidden="true">schedule</span>
        <span
            class="favorite mdc-list-item__meta material-icons" 
            :class="{'active' : stock == 'D'}"
            aria-hidden="true">{{ iconFavorite(stock) }}</span>
        <!--<span data-action="addPortfolio" class="folder mdc-list-item__meta material-icons" aria-hidden="true">folder_open</span>
        <span data-action="addNotification" class="notifications mdc-list-item__meta material-icons" aria-hidden="true">notifications_none</span>-->
      </li>
    </ul>
    <div style="position:absolute; top: 100px; text-align: center; padding: 40px; cursor: not-allowed">
      <p><strong>Si quieres acceder al listado de valores Eurekers inicia sesión.</strong></p>
    </div>
  </div>
</div>
</template>



<script>
import { legacyComponentUsage } from '@/features/chart-usage/adapters/legacyComponentUsage';
import { legacyCollectionStatus } from '../models/legacyCollectionStatus';
import { isSameEntry } from '../models/legacyStockEntry';
import { legacyChartActions, legacyChartActionKey } from '../models/legacyChartActions';
import { legacyStockMembership, legacyStockRowDescription } from '../models/legacyStockMembership';
import Workspaces from '@/features/stockchart/components/Workspaces.vue';
import APICaller from "@/shared/mixins/APICaller.js";
import GetStocks from "@/shared/mixins/GetStocks.js";
import WaitingValues from '@/features/stockchart/components/WaitingValuesAdd.vue';
import LegacySortDialog from './LegacySortDialog.vue';
import LegacyEntryTag from './LegacyEntryTag.vue';
import LegacyEntryDirection from './LegacyEntryDirection.vue';
import LegacyCollectionCounts from './LegacyCollectionCounts.vue';


import { mapMutations, mapGetters } from "vuex";

import { MDCList } from '@material/list';
import { MDCRipple } from '@material/ripple';

export default {
  mixins: [legacyComponentUsage('list'), APICaller, GetStocks],
  components: {
      Workspaces,
      WaitingValues,
      LegacySortDialog,
      LegacyEntryTag,
      LegacyEntryDirection,
      LegacyCollectionCounts,
      
  },
  name: 'Stocks',
  props: { managed: { type: Boolean, default: false } },
  data: () => ({
    stocks: [],
    aux: [],
    ordered_stocks: [],
    selected_ticker: {},
    show_workspace: false,
    show_waiting: false,
    order_by: false,
    order_class: true,
    order_type: 'Nombre A-Z',
    isInitialLoading: true, // Track initial loading state
    title_break_line: "\n",
    position: [],
    select_order_type: false,
    not_ordered: true,
    stock_anonymous:[],
    workspaces: [],
    workspaces_names: [],
    workspaces_colors: [],
    color: "",
    modeOfStocks:'',
    preferences: [],
    order_by_preferences: [
      {id: "Montante", name:["Montante ASC", "Montante DESC"], field:"amount", header: "Montante"},
      {id: "Ticker", name:["Nombre A-Z", "Nombre Z-A"], field: "ticker", header: "Ticker"},
      {id: "Tipo de entrada", name:["Tipo de entrada A-Z", "Tipo de entrada Z-A"], field:"entry_type_name", header: "T. entrada"},
      {id: "Acciones", name:["Acciones ASC", "Acciones DESC"], field:"instrument_number", header: "Acciones"},
      {id: "Entrada", name:["Entrada ASC", "Entrada DESC"], field:"real_entry", header: "Entrada"},
      {id: "Stop", name:["Stop ASC", "Stop DESC"], field:"out_price", header: "Stop"},
      {id: "Soporte", name:["Soporte ASC", "Soporte DESC"], field: "soport", header: "Soporte"},
      {id: "Fecha de soporte", name:["Fecha soporte ASC", "Fecha soporte DESC"], field: "data_soport", header: "Fecha sop."},
      {id: "Valor actual", name:["Valor actual ASC", "Valor actual DESC"], field: "valor_actual", header: "Valor act."},
      {id: "Divisa", name:["Divisa ASC", "Divisa DESC"], field: "cotitzacio_divisa", header: "Divisa"},
      {id: "Rentabilidad", name:["Rentabilidad ASC", "Rentabilidad DESC"], field: "tae_lt", header: "Rentab."},
      {id: "Distancia de entrada", name:["Dist. entrada ASC", "Dist. entrada DESC"], field: "entry_distance", header: "Dist. Ent."},
      {id: "Resistencia", name:["Resistencia ASC", "Resistencia DESC"], field: "resistance", header:"Resist."},
      {id: "Variación anual", name:["Var. anual ASC", "Var. anual DESC"], field: "anual_var", header: "Var. anual"},
      {id: "Número de onda", name:["Núm. de onda ASC", "Núm. de onda DESC"], field: "wave_number", header: "Nº onda"},
      {id: "Siguiente LT", name:["Siguiente LT ASC", "Siguiente LT DESC"], field: "next_entry_lt", header: "Sig. LT"},
      {id: "Primera fecha", name:["Primera fecha ASC", "Primera fecha DESC"], field: "fecha_primera_barra", header: "1ª fecha"},
      {id: "Inversión/Riesgo", name:["Inver./Riesgo ASC", "Inver./Riesgo DESC"], field: "risk_reward", header:"Inv/Riesgo"},
      {id: "Compatibilidad", name:["Compatib. ASC", "Compatib. DESC"], field: "user_platinum_compatibility", header: "Compat."},
      {id: "Comisión de entrada", name:["Comisión ent. ASC", "Comisión ent. DESC"], field: "open_fee", header: "Comisión ent."},
      {id: "Beneficio", name:["Beneficio ASC", "Beneficio DESC"], field: "benefit", header: "Beneficio"},
      {id: "Beneficio asegurado", name:["Beneficio ase. ASC", "Beneficio ase. DESC"], field: "insured_benefit", header: "Benef. Aseg."},
      {id: "Fecha de entrada", name:["Fecha entrada ASC", "Fecha entrada DESC"], field: "in_date", header: "F. entrada"},
      {id: "Fecha añadido", name:["Fecha añadido ASC", "Fecha añadido DESC"], field: "favorite_date", header: "F. añadido"},
    ],
    preferences_selected_to_order: [],
  }),
  mounted() {
    if (!this.managed) this._changeModeToStockMarket();
    this.initMaterialComponent();
    this._getPreferences();

    // Safeguard: Set initial loading to false after 10 seconds maximum
    this.initialLoadTimeout = setTimeout(() => {
      if(this.isInitialLoading) {
        this.isInitialLoading = false;
      }
    }, 10000);

    if (!this.managed) this.stockLoadIntervals.push(setInterval(() => {
      if(this.modeOfStocks != ''){
        if(this._g_IsUserLogged){
          this.getStocks(() => {
            // Signal that stocks are loaded
            this.$emit('stocks-loaded');
          });
        } else {
          // For non-logged-in users, turn off initial loading
          this.isInitialLoading = false;
        }
        clearInterval(this.stockLoadIntervals[0]);
      }
    }, 10));
    
    this._createAnonymousStock();
    var url = window.location.pathname;
    this._initWorkspaces();

    if (this._g_stocks && this._g_stocks.length) { this.stocks = this._g_stocks; this._cloneStockList(); this.isInitialLoading = false; }
  },
  created: function() {
    this.handleKeyup = (e) => {
      if (e.key == 'ArrowDown') {
        this._nextTicker();
      }else if(e.key == "ArrowUp"){
        this._previousTicker();
      }
    };
    window.addEventListener('keyup', this.handleKeyup);
  },
  beforeDestroy: function() {
    clearTimeout(this.initialLoadTimeout);
    window.removeEventListener('keyup', this.handleKeyup);
  },
  watch:{
    chartActionsState: { deep: true, immediate: true, handler(state) { this.$emit('chart-actions-state', state); } },
    ordered_stocks() { this.$nextTick(() => this.$emit('chart-list-ready')); },
    not_ordered() { this.$nextTick(() => this.$emit('chart-list-ready')); },
    '$route': {
      handler: function(to, from){
        if (!from) { return; }
        const prev = from.params && from.params.param1;
        const curr = to && to.params && to.params.param1;
        if (prev !== curr) {
          this._ensureFavoritesDateOption();
          this._checkPreferencesToOrderBy();
        }
      },
      immediate: false
    },
    _g_stocks: {
      handler: function(newVal, oldVal){
        if(newVal != oldVal){
          this.stocks = newVal;
          // Set initial loading to false when stocks are first loaded
          if(this.isInitialLoading) {
            this.isInitialLoading = false;
          }
          let order_preferences_values = this._getOrderParameters();
          this.ordered_stocks = newVal;
          this._cloneStockList();
          this._orderedStock(order_preferences_values.field, order_preferences_values.type, order_preferences_values.name, order_preferences_values.header);
        }
      },
    },

    _g_SelectedTicker: {
      handler: function() {
        this.setSelectedActiveTicker(this._g_SelectedTicker);
      },
      deep: true
    },

    _g_is_loading_stocks: {
      handler: function(newVal, oldVal) {
        // When loading finishes (goes from true to false), end initial loading
        if(oldVal === true && newVal === false && this.isInitialLoading) {
          this.isInitialLoading = false;
        }
      }
    },
  },
  computed: {
    chartActionsState() {
      return legacyChartActions(this._g_SelectedTicker, this._g_User, this._g_IsUserLogged, this._g_UserFeatures, this.workspaces);
    },
    legacyCollectionStatus() { return legacyCollectionStatus; },
    ...mapGetters({stock_type:'_g_GetTypeStocks'}),
    ...mapGetters({_g_stocks:'_g_Stocks'}),
    ...mapGetters({filters:'_g_ShowStockFinderFilter'}),
    ...mapGetters(["_g_IsUserLogged", "_g_SelectedTicker", "_g_is_loading_stocks","_g_User"]),
    ...mapGetters(["_g_order_by"]),
    ...mapGetters(["_g_UserFeatures"]),
    
    entryCount() {
      return this.isInitialLoading || this._g_is_loading_stocks || !Array.isArray(this.stocks) ? '...' : this.stocks.length;
    },
    order_by_icon: function() {
      return (this.order_class) ? 'expand_more' : 'expand_less';
    },
    icon_sort: function() {
      return (this.order_by) ? 'sort' : 'sort';
    }
    
  },
  methods: {
    ...mapMutations(['setStockValue']),
    ...mapMutations(['setMenuSelectionOut']),
    ...mapMutations(["setOrderBy"]),

    _checkCFD: function(stock){
      let cfd_habilitado = "No";
      if(stock.activat_dif == 0) {
        cfd_habilitado = "No";
      } else if(stock.activat_dif == 1) {
        cfd_habilitado = "Alcista";
      } else {
        cfd_habilitado = "Alcista y bajista";
      }

      return cfd_habilitado;
    },

    _getPreferences: function() {
      if(!this._g_User.is_only_authenticated_user){
        let success = response => {
          this.preferences = response.data;
          // Ensure 'Fecha añadido' sort option is synced with current route
          this._ensureFavoritesDateOption();
          this._getPortfolioPreferences();
          //this.tools = response.data;
        }
        
        let url = '/api/v1/stock-finder/preferences'
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('082', 'Error cargando valores.');
  
        this._getAPICall(url, successHandler, failureHandler);
      }
    },

    _favorite_added: function(stock) {
      // Save the currently selected ticker
      const currentSelectedTicker = this.selected_ticker;
      
      for (var i = 0; i < this.stocks.length; i++) {
        if (this.stocks[i].ticker == stock.ticker) {
          stock.favorites = true;
          this.stocks[i].favorites = true;
          
          // Also update in ordered_stocks if present
          if (this.ordered_stocks && this.ordered_stocks.length) {
            for (var j = 0; j < this.ordered_stocks.length; j++) {
              if (this.ordered_stocks[j].ticker == stock.ticker) {
                this.ordered_stocks[j].favorites = true;
              }
            }
          }
          
          // Replace only after all props are updated to ensure reactivity
          this.stocks.splice(i, 1, {...stock});
        }
      }
      
      // No need to call _initWorkspaces() which would cause a reload
      // Instead, just make sure the selected ticker stays the same
      if (currentSelectedTicker) {
        this.setSelectedActiveTicker(currentSelectedTicker);
      }
    },

    _favorite_removed: function(stock) {
      // Save the currently selected ticker
      const currentSelectedTicker = this.selected_ticker;
      
      for (var i = 0; i < this.stocks.length; i++) {
        if (this.stocks[i].ticker == stock.ticker) {
          // Only set favorites=false if there are no more workspaces (folders)
          // containing this stock (folder_name length is 0)
          if (!stock.folder_name || stock.folder_name.length === 0) {
            stock.favorites = false;
            this.stocks[i].favorites = false;
            
            // Also update in ordered_stocks if present
            if (this.ordered_stocks && this.ordered_stocks.length) {
              for (let j = 0; j < this.ordered_stocks.length; j++) {
                if (this.ordered_stocks[j].ticker == stock.ticker) {
                  this.ordered_stocks[j].favorites = false;
                }
              }
            }
          }
          else {
            // If stock still has favorites (belongs to folders), keep favorites=true
            stock.favorites = true;
            this.stocks[i].favorites = true;
            
            // Also update in ordered_stocks if present
            if (this.ordered_stocks && this.ordered_stocks.length) {
              for (let j = 0; j < this.ordered_stocks.length; j++) {
                if (this.ordered_stocks[j].ticker == stock.ticker) {
                  this.ordered_stocks[j].favorites = true;
                }
              }
            }
          }
          
          // Replace for reactivity
          this.stocks.splice(i, 1, {...stock});
        }
      }
      
      // No need to call _initWorkspaces() which would cause a reload
      // Instead, just make sure the selected ticker stays the same
      if (currentSelectedTicker) {
        this.setSelectedActiveTicker(currentSelectedTicker);
      }
    },

    _changeModeToStockMarket: function(){
        let success = (response) => {
          this.modeOfStocks = response;
        };

        let url = "/api/v1/stock-finder/change-search-mode/stock-market";

        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('083', 'Error cambiando modo.');

        this._getAPICall(url, successHandler, failureHandler);

    },

    stockRowDescription: legacyStockRowDescription,
    stockMembership(stock) { return legacyStockMembership(stock, this._g_User, this.workspaces); },

    openStockAction(action, key) {
      if (!['favorites', 'portfolio'].includes(action)) return false;
      const state = this.chartActionsState;
      if (key !== legacyChartActionKey(this._g_SelectedTicker) || !state[action] ||
        (action === 'portfolio' && state.portfolioState === 'open')) return false;
      this.selected_ticker = this._g_SelectedTicker;
      this.show_workspace = action === 'favorites';
      this.show_waiting = action === 'portfolio';
      return true;
    },

    isSameEntry,

    _previousTicker() {
      this._moveEntry(-1);
    },

    _nextTicker() {
      this._moveEntry(1);
    },

    _moveEntry(offset) {
      const stocks = this.not_ordered ? this.stocks : this.ordered_stocks;
      if (!Array.isArray(stocks)) return;
      const index = stocks.findIndex(stock => isSameEntry(stock, this._g_SelectedTicker));
      const next = index + offset;
      if (index >= 0 && next >= 0 && next < stocks.length) {
        this.setSelectedActiveTicker2(stocks[next]);
      }
    },

    _createAnonymousStock: function(){
      for (var i = 0; i < 36; i++){
        let word = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 4);
        this.stock_anonymous.push(word.toUpperCase());
      }
    },
    counter_stocks() {
      // If in initial loading state, stocks are currently loading, or stocks array is not yet initialized, show loading indicator
      if(this.isInitialLoading || this._g_is_loading_stocks == true || this.stocks === undefined || this.stocks === null){
        return "...";
      }
      
      // If not loading, show actual count or 0
      if (this.stocks && this.stocks.length > 0) {
        const uniqueTickers = new Set(this.stocks.map(stock => stock.ticker));
        return uniqueTickers.size;
      } else {
        // Handles cases where this.stocks is an empty array (finished loading but no results)
        return 0;
      }
    },

    initMaterialComponent() {
      const list = new MDCList(document.getElementById('my-list'));
      const adapter = list.getDefaultFoundation().adapter;
      this.counter = adapter.getListItemCount();

      // set properties
      list.vertical = true;
      list.wrapFocus = true;
      list.hasTypeahead = true;
      list.singleSelection = true;
      list.listElements.map((listItemEl) => new MDCRipple(listItemEl));
      if(this._g_IsUserLogged){
        list.listen('MDCList:action', (event) => {
          if(this.not_ordered){
            this.setSelectedActiveTicker2(this.stocks[event.detail.index]);
          }else{
            this.setSelectedActiveTicker2(this.ordered_stocks[event.detail.index]);
          }
        })
      }
    },
    ...mapMutations(['setSelectedTicker']),
    setSelectedActiveTicker(ticker) { 
      this.setSelectedTicker(ticker);
      this.selected_ticker = ticker;
      
    },

    setSelectedActiveTicker2(ticker){
      this.setSelectedTicker(ticker);
      this.selected_ticker = ticker;
    },

    iconFavorite(stock){
      // If the stock is not marked as favorite or doesn't have folder_name, show star_border
      if (!stock.favorites || !stock.folder_name) {
        return 'star_border';
      }
      
      // If the stock has multiple favorites (folders), return 'star'
      // The style will be handled by the template with different colors
      return 'star';
    },

    _initWorkspaces: function() {
      if(!this._g_User.is_only_authenticated_user){
        let success = response => {
          // Clear arrays first to prevent duplicates
          this.workspaces = [];
          this.workspaces_names = [];
          this.workspaces_colors = [];
          
          if (response.data == [] || response.data.folders == undefined) {
            this.workspaces = [];
          }
          else {
            for (let index = 0; index < response.data.folders.length; index++) {
              const name = response.data.folders[index][0];
              const color = response.data.folders[index][1];
              
              this.workspaces.push({
                name: name,
                color: color,
                isFavorite: false,
              });
              this.workspaces_names.push(name);
              this.workspaces_colors.push(color);
            }
          }
          
          // Get stocks again if it's not the initial load but a workspace update
          if (this.initialized) {
            // Give time for the backend to update its workspace data
            setTimeout(() => {
              this.getStocks(() => {
                // Force re-render by triggering a refresh after stocks are loaded
                this._refreshStockWorkspaceColors();
              });
            }, 100);
          } else {
            this.initialized = true;
            // Just refresh colors for the initial load
            this._refreshStockWorkspaceColors();
          }
        };
  
        let url = '/api/v1/stock-finder/favorite-folder/list';
              
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('086', 'Error cargando listas de favoritos.');
  
        this._getAPICall(url, successHandler, failureHandler);
      }            
    },

    _refreshStockWorkspaceColors: function() {
      // Create a shallow copy of each stock to trigger reactivity
      if (this.stocks && this.stocks.length) {
        // Re-map folder names to colors based on current workspaces
        this.stocks = this.stocks.map(stock => {
          // Create a new reference to trigger reactivity
          const newStock = {...stock};
          return newStock;
        });
        
        // Also update ordered stocks if they exist
        if (this.ordered_stocks && this.ordered_stocks.length) {
          this.ordered_stocks = this.ordered_stocks.map(stock => ({...stock}));
        }
      }
    },

    _getColorByWorkspace(workspace){
      var index = 0;
      if(this.workspaces_names.includes(workspace)){
        index = this.workspaces_names.indexOf(workspace);
      }
      return this.workspaces_colors[index];
    },

    iconSchedule(stock){
      return (stock.waitings_portfolio_name != undefined) ? 'schedule' : 'more_time';  
    },

    orderBy() {
      this.order_by = !this.order_by;
    },

    _cloneStockList: function(){
      this.ordered_stocks = [];
      for (let i = 0; i < this.stocks.length; i++) {
        this.ordered_stocks[i] = this.stocks[i];
      }
    },

    _closeFavoriteWorkspacesWindow() {
      this.show_workspace = false;
    },

    _closeWaitingValueWindow() {
      this.show_waiting = false;
    },

    _changeOrderType: function(value){
      if(value == "open"){
        this.select_order_type = true;
        this.order_class = false;
      }else{
        const wasOpen = this.select_order_type;
        this.select_order_type = false;
        this.order_class = true;
        if (wasOpen) this.$nextTick(() => { if (this.$refs.orderTrigger) this.$refs.orderTrigger.focus(); });
      }
    },

    _orderedStock: function(field, type, name, header){
      if(field == 'anual_var'){
        field = 'tae';
      }
      if(this.stocks) {
        for(let i = 0; i < this.stocks.length; i++){
          this.ordered_stocks[i] = this.stocks[i];
        }
        if(type == "asc"){
          this.ordered_stocks.sort((a,b) => {
            if (this.isNumeric(a[field]) && this.isNumeric(b[field])) {
              return parseFloat(a[field]) > parseFloat(b[field]) ? 1 : -1;
            } else {
              return a[field] > b[field] ? 1 : -1;
            }
          })
          this.not_ordered = false;
          this.order_type = name
          let setOrder = [type, header]
          this.setOrderBy(setOrder)
        }else if(type == "desc"){
          this.ordered_stocks.sort((a,b) => {
            if (this.isNumeric(a[field]) && this.isNumeric(b[field])) {
              return parseFloat(a[field]) < parseFloat(b[field]) ? 1 : -1;
            } else {
              return a[field] < b[field] ? 1 : -1;
            }
          })
          this.not_ordered = false;
          this.order_type = name
          let setOrder = [type, header]
          this.setOrderBy(setOrder)
        }
        this._changeOrderType("close");
      }
    },

    isNumeric : function(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },

    _getOrderParameters(){
      
      let order_preferences = {
        field: "",
        header: "",
        name: "",
        type: ""
      };

      for(let i = 0; i < this.order_by_preferences.length; i++){
        if(this.order_by_preferences[i].header == this._g_order_by[1]){
          order_preferences.field = this.order_by_preferences[i].field;
          order_preferences.header = this.order_by_preferences[i].header;
          if(this._g_order_by[0] == 'asc'){
            order_preferences.type = 'asc';
            order_preferences.name = this.order_by_preferences[i].name[0]
          } else {
            order_preferences.type = 'desc';
            order_preferences.name = this.order_by_preferences[i].name[1];
          }
        }
      }

      return order_preferences;
    },

    _checkPreferencesToOrderBy: function(){
      let temp = [];
      // Reset selection to avoid duplicates when route/preferences change
      this.preferences_selected_to_order = [];
      for(let i = 0; i < this.order_by_preferences.length; i++){
        temp.push(this.order_by_preferences[i].id)
      }
      this.preferences.forEach(element =>{
        if(temp.indexOf(element.name) != -1){
          let index = temp.indexOf(element.name);
          this.preferences_selected_to_order.push(this.order_by_preferences[index])
        }
      })
      this._checkWhatPreferenceIsOrdered()
    },

    _ensureFavoritesDateOption: function(){
      const isFavorites = this.$route && this.$route.params && this.$route.params.param1 === 'favorites';
      const hasFechaAnadido = this.preferences && this.preferences.some(p => p.name === 'Fecha añadido');
      if (isFavorites && !hasFechaAnadido) {
        this.preferences.push({ name: 'Fecha añadido' });
      } else if (!isFavorites && hasFechaAnadido) {
        this.preferences = this.preferences.filter(p => p.name !== 'Fecha añadido');
      }
    },

    _getPortfolioPreferences: function(){
      let success = response =>{
        if(response.data.indexOf("open_fee") != -1){
          this.preferences.push({field: "open_fee", help_text: "", name:"Comisión de entrada", sorter:"Comisión ent.", subfix: "", type: ""})
        }
        if(response.data.indexOf("benefit") != -1){
          this.preferences.push({field: "benefit", help_text: "", name:"Beneficio", sorter:"Beneficio", subfix: "", type: ""})
        }
        if(response.data.indexOf("insured_benefit") != -1){
          this.preferences.push({field: "insured_benefit", help_text: "", name:"Beneficio asegurado", sorter:"Benef. Aseg.", subfix: "", type: ""})
        }
        if(response.data.indexOf("in_date") != -1){
          this.preferences.push({field: "in_date", help_text: "", name:"Fecha de entrada", sorter:"F. entrada", subfix: "", type: ""})
        }
        this._checkPreferencesToOrderBy();
      }

      let url = "/api/v1/portfolio-preferences"

      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('086', 'Error cargando preferencias de cartera.');

      this._getAPICall(url, successHandler, failureHandler);
    },

    _checkWhatPreferenceIsOrdered: function(){
      let temp = []
      for(let i = 0; i < this.preferences_selected_to_order.length; i++){
        temp.push(this.preferences_selected_to_order[i].header)
      }
      let index = temp.indexOf(this._g_order_by[1])
      let element = this.preferences_selected_to_order[index]
      let name = ""
      if(element) {
        if(this._g_order_by[0] == "asc"){
          name = element.name[0]
        }else{
          name = element.name[1]
        }
        this._orderedStock(element.field, this._g_order_by[0], name, element.header)
      }
    }
  },
}
</script>


<style lang="scss" scoped>
@use "@material/list";

@include list.core-styles;
@include list.item-selected-text-color(black);

.mdc-list-item {
  @include list.item-primary-text-ink-color(#444);
  @include list.list-item-height(52px);
  border-bottom: 1px solid #e9e9e9;
}

:not(.mdc-list-item--disabled).mdc-list-item--selected .mdc-list-item__ripple[data-v-1d7efbc2]::before {
    background-color: var(--mdc-ripple-color, var(--mdc-theme-primary, red));
}

li.mdc-list-item {display:flex;}
.legacy-stock-row-content { flex: 1 1 auto; min-width: 0; color: var(--legacy-list-text, var(--color-primary-secondary)); }
.legacy-stock-row-main { display: flex; align-items: center; gap: 5px; min-width: 0; }
.legacy-stock-row-main > .mdc-list-item__text { flex: 0 0 auto; font-size: 13px; font-weight: 700; }
.legacy-stock-row-separator { flex: none; opacity: .6; }
.legacy-stock-row-company { flex: 1 1 auto; min-width: 0; font-size: 11px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.legacy-stock-row-analysis { display: flex; flex: 0 0 auto; flex-direction: column; align-items: flex-end; justify-content: space-between; align-self: stretch; margin-left: 6px; padding: 9px 0; }
#my-list .legacy-stock-row-analysis ::v-deep .legacy-entry-tag { margin: 0; padding: 0; border: 0; border-radius: 0; font-size: 11px; line-height: 16px; font-weight: 600; color: var(--legacy-list-muted, #607080); opacity: 1; }
.legacy-stock-row-description { margin-top: 3px; font-size: 10px; line-height: 14px; color: var(--legacy-list-muted, #607080); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* Inset marks occupy no list width and coexist with the selected background. */
.legacy-stock-favorite-mark {
  position: absolute;
  inset: 0 auto 0 0;
  width: 3px;
  background: var(--stock-favorite-mark);
  pointer-events: none;
}

li span.mdc-list-item__meta.material-icons {margin:unset; margin-left: 4px}
li span.mdc-list-item__meta.material-icons.push {margin-left: auto;}

.mdc-list-item.mdc-list-item--selected::before {
  display:none;
}
.legacy-stock-portfolio-mark {
  position: absolute;
  inset: 0 1px 0 auto;
  width: 3px;
  box-sizing: border-box;
  border-left: 1px solid var(--legacy-portfolio-mark-edge, transparent);
  background: #0f0f1a;
  pointer-events: none;
}

.mdc-list-item--selected .legacy-stock-row-description,
#my-list .mdc-list-item--selected ::v-deep .legacy-entry-tag { color: var(--legacy-list-selected-muted, #526175); }


.mdc-list-item--selected .typo-body-2{
  font-weight:bold;
}

li.mdc-list-item--selected .material-icons {
  &.alarm:hover {color:green}
  &.notifications:hover {color:orange;}
  &.favorite:hover {color:#00add8;}
  &.folder:hover{color: #89430C;}
}

li.mdc-list-item .material-icons {
  &.alarm.active {color:green}
  &.notifications.active {color:orange;}
  &.favorite.active {color:#00add8;}
  &.folder.active{color: #89430C;}
}

.favorite, .alarm {
  font-size: 22px;
}

/* Add style for multi-favorite white stars */
.stock-icon-on-bg {
  color: white !important;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.7);
}

.ekers-event-click {
  cursor:pointer;
}
.stocks-container{
  margin-left: 12px;
  background-color: var(--color-background-background);
  border-right: 1px solid var(--color-custom-only-dark-theme-border);
}

.stocks-order-query{
  height: 30px;
  border: 1px solid rgba(15, 15, 26, 0.2);
}

.stocks-order-query:hover{
  cursor: pointer;

}

.blured{
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
  background-color: white;
}

.mdc-list-item__text{
  color: var(--color-primary-secondary);
}

.stocks-info-query{
  background-color: var(--color-primary-900);
}

.stocks-query-not-found{
  padding: 20px;
  text-align: center;
  color: var(--color-text-secondary);
}

.star-margin{
  margin-left: auto !important;
}

.not-allowed-stocks{
  color: #00add9;
}

/* Loading styles */
.stocks-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  min-height: 200px;
}

.loading-spinner {
  text-align: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #00add8;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-spinner p {
  color: var(--color-text-secondary, #666);
  font-size: 14px;
  margin: 0;
}
</style>
